module.exports = __webpack_public_path__ + "img/studio-7-wh.6ca6d783.svg";